import "./index.css"
import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { obtenerHotelCotizacion } from "../../../ducks/clientesDuck"
import { formatDinero } from "../../../utils/formatDinero"
import { Tooltip } from "@material-ui/core"
import GroupIcon from '@material-ui/icons/Group'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'

const TarjetaHotel = () => {
    const { idCotizacion, hotelCotizacion } = useSelector(store => store.cliente)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(obtenerHotelCotizacion({ idCotizacion }))
    }, [dispatch, idCotizacion])

    if (idCotizacion === 0)
        return null

    if (hotelCotizacion.length <= 0)
        return null

    return (
        <div className="TarjetaHotel-root">
            <div className="contenido">
                {
                    hotelCotizacion.map((hotel, index) =>
                        <div key={index}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <ul style={{ listStyle: 'none', display: "flex", flexFlow: "column", justifyContent: "center", alignItems: "flex-start", padding: "0 0 0 10px" }}>
                                    <li style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                        <Tooltip title="Costo">
                                            <MonetizationOnIcon color="secondary" />
                                        </Tooltip>
                                        {`${formatDinero(hotel.Costo)}`}
                                    </li>
                                    <li style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                        <Tooltip title="Comision">
                                            <MonetizationOnIcon color="primary" />
                                        </Tooltip>
                                        {formatDinero(hotel.Comision)}
                                    </li>
                                </ul>
                                <ul style={{ listStyle: 'none', display: "flex", flexFlow: "column", justifyContent: "center", alignItems: "flex-start", padding: "0 0 0 10px" }}>
                                    <li style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                        <Tooltip title="Total">
                                            <GroupIcon color="primary" />
                                        </Tooltip>
                                        {hotel.Cantidad}
                                    </li>
                                    <li style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                        <Tooltip title="Total">
                                            <MonetizationOnIcon color="secondary" />
                                        </Tooltip>
                                        {formatDinero(hotel.Total)}
                                    </li>
                                </ul>
                            </div>
                            <div style={{ padding: "20px" }} dangerouslySetInnerHTML={{ __html: `${hotel.Hotel}` }} />
                        </div>
                    )
                }
            </div>
        </div>
    )
}
export default TarjetaHotel